export const TEMPORARILY_UNAVAILABLE = 'Temporarily unavailable';
export const SOLD_OUT_ONLINE = 'SOLD OUT ONLINE';
export const NOT_AVAILABLE = 'Sorry, this item is not available';
export const GTM_TRACKED_CONFLICTS = [
  TEMPORARILY_UNAVAILABLE.toLowerCase(),
  SOLD_OUT_ONLINE.toLowerCase(),
];
export const AVAILABLE = 'available';
export const UNAVAILABLE = 'unavailable';
